<template>
  <div>
    <div class="owner_title">其余费用支出</div>
    <!-- 筛选 -->
    <div class="btn_box">
      <div class="day_record_btn">
        <div class="fee_add_btn" @click="addFee()">
          <i class="iconfont icon-jiahao"></i>
          新增
        </div>
      </div>
      <div class="task_filtrate" @click="show_filter_form()">
        <i class="iconfont icon-shaixuan1"></i>
        <span>筛选</span>
      </div>
    </div>

    <!-- 筛选表单 -->
    <div class="task_filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="创建人" prop="name">
          <el-input v-model="filter_form.name"></el-input>
        </el-form-item>
        <el-form-item label="支付宝" prop="alipay">
          <el-input v-model="filter_form.alipay"></el-input>
        </el-form-item>
        <el-form-item label="金额" prop="money">
          <el-input v-model="filter_form.money"></el-input>
        </el-form-item>

        <el-form-item label="流程状态" prop="status">
          <el-select v-model="filter_form.status" placeholder="流程状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="进行中" value="0"></el-option>
            <el-option label="已结束" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注说明" prop="remarks">
          <el-input v-model="filter_form.remarks"></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="filter_form.createtime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-button type="primary" icon="el-icon-search" @click="goSearch"
          >搜索</el-button
        >
      </el-form>
    </div>

    <div class="task_box">
      <!-- 表格数据 -->
      <el-table :data="dataShow" height="550" tooltip-effect="dark" border>
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="name"
          label="创建人"
          align="center"
          sortable
          :width="equipmentType == 0 ? 200 : 90"
        ></el-table-column>
        <el-table-column
          property="alipay"
          label="支付宝"
          align="center"
          sortable
          :width="equipmentType == 0 ? 180 : 90"
        ></el-table-column>
        <el-table-column
          property="money"
          label="金额"
          align="center"
          sortable
          :width="equipmentType == 0 ? 150 : 80"
        ></el-table-column>
        <el-table-column
          property="status"
          label="流程状态"
          align="center"
          sortable
          :width="equipmentType == 0 ? 150 : 110"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.status == '0' ? '' : 'info'">
              {{ scope.row.status == "0" ? "进行中" : "已结束" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          property="remarks"
          label="备注说明"
          align="center"
          sortable
          :width="equipmentType == 0 ? 150 : 108"
        ></el-table-column>
        <el-table-column property="images" label="图片" align="center" sortable>
          <template slot-scope="scope">
            <img
              v-for="(item, index) in scope.row.images"
              :key="index"
              :src="baseUrl + item"
              class="fee_picture"
            />
          </template>
        </el-table-column>

        <el-table-column
          property="createtime"
          label="创建时间"
          align="center"
          sortable
          :width="equipmentType == 0 ? 200 : 108"
        >
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { z_index } from "@/utils/api";
export default {
  data() {
    return {
      baseUrl: this.$global.commonUrl,
      feeExpenditureList: [], //日结登记列表
      feeImageList: [], //图片列表
      isFilterForm: true, //筛选表单
      currentId: null, //当前选中的id
      selectIdList: [], //多选列表
      selectIds: [], //多选id列表
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      // 筛选
      filter_form: {
        name: "", //姓名
        money: "", //金额
        remarks: "", //备注
        alipay: "", //支付宝
        createtime: "", //创建时间
        status: "" //流程状态
      },
      select_time_data: "",
      time_filter: "", //时间筛选
      equipmentType: 0 //设备 0-pc端 1移动端
    };
  },
  created() {
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;
    if (this.$isMobile.isDeviceType()) {
      this.equipmentType = 1;
    } else {
      this.equipmentType = 0;
    }
    this.getFeeList();
  },
  methods: {
    // 获取金主日结登记列表
    getFeeList(time) {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId,
        page: 1,
        page_index: 10
      };
      z_index(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.feeExpenditureList = res.data.data;

          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 新增其余支出费用
    addFee() {
      var that = this;
      that.$router.push("/ownerFeeExpenditureAdd");
    },
    // 筛选
    goSearch() {
      var that = this;
      var date1, date2;
      that.select_time_data = that.filter_form.createtime;
      date1 = that.select_time_data[0];
      date2 = that.select_time_data[1];
      if (date1 == undefined && date2 == undefined) {
        that.time_filter = "";
      } else {
        that.time_filter = date1 + " - " + date2;
      }
      that.filter_form.createtime = that.time_filter;
      let obj = {
        departmentuser_id: that.ownerId,
        page: 1,
        page_index: 10,
        ...that.filter_form
      };
      console.log("参数", obj);
      z_index(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.feeExpenditureList = res.data.data;
          that.calcPageData();
          that.filter_form.createtime = that.select_time_data;
          console.log("时间", that.time_filter);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },

    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 计算页数的方法
    calcPageData() {
      // 计算页数，根据后台数据的条数和每页要显示的数量算出一共多少页，得0时设为1
      if (this.feeExpenditureList.length > 1) {
        this.pageNum =
          Math.ceil(this.feeExpenditureList.length / this.pageSize) || 1;
      }
      //数据分组
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.feeExpenditureList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }
      // 获取到数据后显示第一页内容，数组下标是从0开始的，这里一定 要减去1，不然会丢失一组数据
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      // 重新计算页数并分组
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      // 注意数组是从0开始，页码别忘了减去1
      this.dataShow = this.totalPageData[val - 1];
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}

.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
}
.day_record_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background: #ffffff;
  border: 1px solid #e4e9f1;
}

.table_box {
  margin: 0px 15px;
}

.reject_record_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  border-radius: 10px;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
}
.reject_record_btn i {
  font-size: 12px;
}

.sea_icon {
  font-size: 12px;
}
.task_box {
  margin: 0px 15px;
}

.task_filtrate {
  text-align: right;
  padding: 10px 15px 10px 15px;
}

.task_filtrate i {
  font-size: 14px;
}

.task_filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}

.task_filter_form {
  background: #ffffff;
  margin: 0px 16px;
  padding-top: 15px;
}

.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.btn_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 15px 15px 10px 15px;
}
.fee_add_btn {
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #157df8;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  margin-right: 5px;
}

.day_record_btn {
  display: flex;
  flex-direction: row;
}
.fee_picture {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .task_box {
    margin-bottom: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/owner/OwnerFeeExpenditure.vue